module.exports = __webpack_public_path__ + "img/appstore.0a3f1b15.png";